import { useAppDispatch } from '@/store/store-hooks'
import deleteUserSkill from '@/user-skills/fetch/delete-user-skill'
import postUserSkill from '@/user-skills/fetch/post-user-skill'
import putUserSkill from '@/user-skills/fetch/put-user-skill'
import type { UserSkillWrite } from '@/user-skills/schemas'
import { UserSkillLibraryActions } from '@/user-skills/store/library.slice'
import { UserSkillSelectionActions } from '@/user-skills/store/selection.slice'

export function useUserSkillMutations() {
  const dispatch = useAppDispatch()
  const saveSkill = async (skillId: string | undefined, content: UserSkillWrite): Promise<string | void> => {
    try {
      if (skillId) {
        await putUserSkill(skillId, content)
        return
      }
      return (await postUserSkill(content)).id
    } finally {
      dispatch(UserSkillLibraryActions.refreshLibrary({ force: true }))
    }
  }
  const removeSkill = async (skillId: string) => {
    try {
      await deleteUserSkill(skillId)
      dispatch(UserSkillSelectionActions.skillDeleted(skillId))
    } finally {
      dispatch(UserSkillLibraryActions.refreshLibrary({ force: true }))
    }
  }
  return { saveSkill, removeSkill }
}
